// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutBucketingBar-cls1_L2G","cls2":"LoggedOutBucketingBar-cls2_qLr LoggedOutBucketingBar-cls1_L2G"};